export default function waitlist(state = {}, action) {
  switch (action.type) {
    case 'SET_WAITLIST_RESERVATION': {
      return { ...state, [action.payload.variant_id]: action.payload }
    }
    default:
      return state
  }
}
